export default __webpack_public_path__ + "static/media/AcessosIconGray.c0a28c2a.svg";